import { render, staticRenderFns } from "./ThePersonalAddressesCard.vue?vue&type=template&id=580ec3b0&"
import script from "./ThePersonalAddressesCard.vue?vue&type=script&lang=js&"
export * from "./ThePersonalAddressesCard.vue?vue&type=script&lang=js&"
import style0 from "./ThePersonalAddressesCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports